<template>
    <v-card @click="clickListener" class="headline-item" tile elevation="0">
        <v-img v-if="src" class="white--text align-end" :height="srcHeight" :src="src">
            <v-card-title v-if="subtitle" class="primary">{{subtitle}}</v-card-title>
        </v-img>
        <v-list-item two-line class="px-6">
            <v-list-item-content>
                <v-list-item-title class="text-h6 font-weight-regular mb-1 primary--text">{{title}}</v-list-item-title>
                <span v-html="message"></span>
            </v-list-item-content>
        </v-list-item>
        <v-divider v-if="divider" class="mx-6"></v-divider>
    </v-card>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        clickListener() {
            this.$emit("click");
        },
        clickHeadlineArticle(item) {
            //if(item.hasOwnProperty("url")) {
//                window.open(item.url, "_blank");
  //          }
        }
    },
    props: {
        srcHeight: {
            type: String,
            default: "250px"
        },
        src: String,
        url: String,
        title: String,
        subtitle: String,
        message: String,
        divider: Boolean
    }
}
</script>
<style lang="scss" scoped>
.headline-item {
    .headline {
        white-space: normal;
    }
    span {
        font-size: 1em;
    }
    &.news-item-video {
        background-color: rgb(240, 240, 240);
    }
    .v-card__title {
        text-transform: uppercase;
        font-size: 1em;
        padding: 5px 20px;
        position: absolute;
        left: 0;
        bottom: 15px;
    }
    .v-card__text, .v-card__title {
        word-break: normal; /* maybe !important  */
    }
}
</style>